// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content-wrapper {
	display: flex;
	flex-direction: column;
	position: absolute;
	inset: 5vw;
	z-index: 10005;
	align-content: center;
	align-items: center;
	justify-content: space-between;
	background-color: white;
	height: fit-content;
	border: 1px solid rgba(0, 0, 0, 0.3);
	border-radius: 6px;
	box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 7px;
}

.modal-close-button {
	background: url("https://cdn.iubenda.com/close.png") no-repeat scroll 0 0
		transparent;
	border: medium none;
	display: block;
	height: 24px;
	position: absolute;
	right: -9px;
	top: -10px;
	width: 23px;
	cursor: pointer;
	z-index: 10010;
}

.modal-background-generic {
	position: absolute;
	inset: 0rem;
	background-color: rgba(19, 18, 18, 0.8);
	z-index: 5004;
}
.modal-content-generic {
	display: flex;
	flex-direction: column;
	background-color: transparent;
	color: black;
	padding: 5vw;
	overflow: scroll;
	height: 80vh;
}

.modal-action-bar {
	display: flex;
	margin: 1rem;
	align-self: flex-end;
	align-content: flex-end;
}
.modal-content-generic p {
	font-size: 1.4rem;
	text-align: justify;
	line-height: 2.5rem;
}
.modal-content-generic h1 {
	font-size: 2rem;
	text-align: center;
}
.modal-content-generic a {
	font-size: 1.4rem;
	margin: 0rem 1rem;
}
.modal-button-generic {
	display: flex;
	background-color: rgb(75, 74, 74);
	border-radius: 0.5rem;
	align-self: flex-end;
	box-shadow: 1px 1px 3px 1px rgb(60, 60, 60);
	height: 3rem;
	width: 7rem;
	align-items: center;
	justify-content: center;
}
.modal-button-generic.accept {
	background-color: var(--primary-color1);
}

.modal-button-generic.decline {
	background-color: var(--primary-color2);
}

.modal-button-generic:hover {
	background-color: var(--primary-color2);
}
.modal-button-generic p {
	color: white;
}

@media (min-width: 500px) {
	.modal-content-wrapper {
		inset: calc(2.4vw + 4vw);
		height: fit-content;
	}

	.modal-content-generic {
		padding: 2vw;
		color: black;
		z-index: 5002;
		align-content: center;
		align-items: center;
		overflow: scroll;
		height: 70vh;
	}
}

.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal {
	padding-left: 20px !important;
	margin: 0rem 0.2rem !important;
}
.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal:hover {
	box-shadow: 1px 1px 3px 1px black;
	padding-left: 20px !important;
	margin: 0rem 0.2rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericModal/genericModal.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,mBAAmB;CACnB,8BAA8B;CAC9B,uBAAuB;CACvB,mBAAmB;CACnB,oCAAoC;CACpC,kBAAkB;CAClB,0CAA0C;AAC3C;;AAEA;CACC;aACY;CACZ,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;CACX,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,uCAAuC;CACvC,aAAa;AACd;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,uBAAuB;AACxB;AACA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iCAAiC;CACjC,qBAAqB;CACrB,oBAAoB;CACpB,2CAA2C;CAC3C,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,YAAY;AACb;;AAEA;CACC;EACC,wBAAwB;EACxB,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;CACb;AACD;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;CACC,iCAAiC;CACjC,6BAA6B;CAC7B,8BAA8B;AAC/B","sourcesContent":[".modal-content-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: absolute;\n\tinset: 5vw;\n\tz-index: 10005;\n\talign-content: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: white;\n\theight: fit-content;\n\tborder: 1px solid rgba(0, 0, 0, 0.3);\n\tborder-radius: 6px;\n\tbox-shadow: rgba(0, 0, 0, 0.3) 0px 3px 7px;\n}\n\n.modal-close-button {\n\tbackground: url(\"https://cdn.iubenda.com/close.png\") no-repeat scroll 0 0\n\t\ttransparent;\n\tborder: medium none;\n\tdisplay: block;\n\theight: 24px;\n\tposition: absolute;\n\tright: -9px;\n\ttop: -10px;\n\twidth: 23px;\n\tcursor: pointer;\n\tz-index: 10010;\n}\n\n.modal-background-generic {\n\tposition: absolute;\n\tinset: 0rem;\n\tbackground-color: rgba(19, 18, 18, 0.8);\n\tz-index: 5004;\n}\n.modal-content-generic {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: transparent;\n\tcolor: black;\n\tpadding: 5vw;\n\toverflow: scroll;\n\theight: 80vh;\n}\n\n.modal-action-bar {\n\tdisplay: flex;\n\tmargin: 1rem;\n\talign-self: flex-end;\n\talign-content: flex-end;\n}\n.modal-content-generic p {\n\tfont-size: 1.4rem;\n\ttext-align: justify;\n\tline-height: 2.5rem;\n}\n.modal-content-generic h1 {\n\tfont-size: 2rem;\n\ttext-align: center;\n}\n.modal-content-generic a {\n\tfont-size: 1.4rem;\n\tmargin: 0rem 1rem;\n}\n.modal-button-generic {\n\tdisplay: flex;\n\tbackground-color: rgb(75, 74, 74);\n\tborder-radius: 0.5rem;\n\talign-self: flex-end;\n\tbox-shadow: 1px 1px 3px 1px rgb(60, 60, 60);\n\theight: 3rem;\n\twidth: 7rem;\n\talign-items: center;\n\tjustify-content: center;\n}\n.modal-button-generic.accept {\n\tbackground-color: var(--primary-color1);\n}\n\n.modal-button-generic.decline {\n\tbackground-color: var(--primary-color2);\n}\n\n.modal-button-generic:hover {\n\tbackground-color: var(--primary-color2);\n}\n.modal-button-generic p {\n\tcolor: white;\n}\n\n@media (min-width: 500px) {\n\t.modal-content-wrapper {\n\t\tinset: calc(2.4vw + 4vw);\n\t\theight: fit-content;\n\t}\n\n\t.modal-content-generic {\n\t\tpadding: 2vw;\n\t\tcolor: black;\n\t\tz-index: 5002;\n\t\talign-content: center;\n\t\talign-items: center;\n\t\toverflow: scroll;\n\t\theight: 70vh;\n\t}\n}\n\n.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal {\n\tpadding-left: 20px !important;\n\tmargin: 0rem 0.2rem !important;\n}\n.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal:hover {\n\tbox-shadow: 1px 1px 3px 1px black;\n\tpadding-left: 20px !important;\n\tmargin: 0rem 0.2rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
